import { cn } from "@/lib/utils";
import { Progress } from "@/components/ui/progress";
import { useTranslations } from "next-intl";

interface LoadingOverlayProps {
  message?: string;
  progress?: {
    fileUploaded: boolean;
    analyzing: boolean;
    extracting: boolean;
    creating: boolean;
  };
}

export function LoadingOverlay({ message, progress }: LoadingOverlayProps) {
  const t = useTranslations("Loading");

  const getProgressValue = () => {
    if (!progress) return 0;
    const steps = [
      progress.fileUploaded,
      progress.analyzing,
      progress.extracting,
      progress.creating,
    ];
    return (steps.filter(Boolean).length / steps.length) * 100;
  };

  const getMessage = () => {
    if (message) return message;
    if (!progress) return t("processing");

    if (progress.creating) return t("creatingMenu");
    if (progress.extracting) return t("extractingMenuDetails");
    if (progress.analyzing) return t("analyzingMenu");
    if (progress.fileUploaded) return t("processingFile");
    return t("startingProcess");
  };

  return (
    <div
      className={cn(
        "fixed inset-0 bg-background/95 backdrop-blur-sm z-50",
        "flex flex-col items-center justify-center"
      )}
    >
      <div className="w-full max-w-md space-y-8 p-8">
        <div className="space-y-4 text-center">
          <div className="h-12 w-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mx-auto" />
          <h3 className="text-xl font-medium">{getMessage()}</h3>
          {progress && (
            <Progress value={getProgressValue()} className="h-2 w-full" />
          )}
        </div>
      </div>
    </div>
  );
}
